import { AddNewForm } from '../../../components/News/AddForm'

export function AddArticle() {
    return <AddNewForm />
}
